module.exports = __webpack_public_path__ + "img/cert2.314c44a3.jpg";